import request from '@/utils/request'

 // 查询物料来源列表
  export function apiScpMrpSrAssignmentSetsList (query) {
    return request({
      url: `/mdm/mdmOrgSrAssignments/list`,
      method: 'get',
      params: query
    })
  }
 // 新增来源规则分配集
 export function apiNewMdmOrgSrAssignmentSets (query) {
  return request({
    url: `/mdm/mdmOrgSrAssignmentSets`,
    method: 'post',
    data: query
  })
}

 // 同步物料来源
 export function apiUpdateMdmOrgSrAssignmentSets (query) {
  return request({
    url: `/mdm/mdmOrgSrAssignments/saveOrUpdateData`,
    method: 'post',
    data: query
  })
}
 // 更新物料来源
 export function apiChangeMdmOrgSrAssignments (query) {
  return request({
    url: `/mdm/mdmOrgSrAssignments`,
    method: 'put',
    data: query
  })
}

 // 删除物料来源
 export function apiDelMdmOrgSrAssignments (ids) {
  return request({
    url: `/mdm/mdmOrgSrAssignments/${ids}`,
    method: 'delete'
  })
}

 // 查询分配比例列表
 export function apiScpMpsDistributionRatioList (query) {
  return request({
    url: `/scp/scpMpsDistributionRatio/list`,
    method: 'get',
    params: query

  })
}

 // 修改分配比例
 export function apiUpdateScpMpsDistributionRatio (query) {
  return request({
    url: `/scp/scpMpsDistributionRatio`,
    method: 'put',
    data: query
  })
}

// 导出列表
export function apiScpMpsDistributionRatioNewExport (data) {
  return request({
    url: '/scp/scpMpsDistributionRatio/v2/export',
    method: 'post',
    data: data
  })
}

 // 删除分配比例
 export function apiDeleteScpMpsDistributionRatio (ids) {
  return request({
    url: `/scp/scpMpsDistributionRatio/${ids}`,
    method: 'delete'
  })
}

// 导出
export function apiExportScpMpsDistributionRatio (data) {
  return request({
    url: '/mdm/mdmOrgSrAssignments/v2/exportNew',
    method: 'post',
    data: data
  })
}
